import React from "react";
import { Text, Button, Card } from "@merge-api/merge-javascript-shared";
import { ChevronRight } from "lucide-react";

export interface TileWithImageProps {
  img: React.ReactElement;
  title: string;
  subtitle?: JSX.Element;
  buttonName: string;
  docsUrl: string;
}

// All styled-components and Row replaced with Tailwind CSS classes below.
const SelectOneStep = ({ img, title, subtitle, buttonName, docsUrl }: TileWithImageProps) => (
  <Card className="w-full flex flex-col p-5">
    <Text variant="h5" as="p" className="flex items-center flex-row">
      <span className="mr-3">{img}</span>
      {title}
    </Text>
    <Text as="p">{subtitle}</Text>
    <div className="flex flex-col justify-center items-end">
      <Button
        size="sm"
        rightIcon={<ChevronRight size={12} />}
        onClick={() => window.open(docsUrl, "_blank")}
      >
        {buttonName}
      </Button>
    </div>
  </Card>
);

export default SelectOneStep;
